import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import OcApp from './OcApp';

// OC abre em /#oc reusando o token guardado (OcApp acha sozinho).
// ?api=self -> chamadas relativas (proxy/rewrite do Amplify p/ staging);
// ?api=<url> -> aponta para outro backend; sem ?api -> producao.
const root = ReactDOM.createRoot(document.getElementById('root'));
const rawHash = typeof window !== 'undefined' ? window.location.hash.replace(/^#/, '') : '';
const isOc = rawHash.split('?')[0] === 'oc';
const apiOv = new URLSearchParams(rawHash.split('?')[1] || '').get('api');
const apiBase = apiOv === 'self' ? '' : (apiOv || undefined);

root.render(
  <React.StrictMode>
    {isOc ? <OcApp apiBase={apiBase} /> : <App />}
  </React.StrictMode>
);
